export const FETCH_STATIC_JOB_ROLES = 'candidateExperience/views/roleList/FETCH_STATIC_JOB_ROLES'
export const FETCH_STATIC_JOB_ROLES_SUCCESS = 'candidateExperience/views/roleList/FETCH_STATIC_JOB_ROLES_SUCCESS'
export const FETCH_STATIC_JOB_ROLES_ERROR = 'candidateExperience/views/roleList/FETCH_STATIC_JOB_ROLES_ERROR'

export const fetchStaticJobRoles = () => ({
  type: FETCH_STATIC_JOB_ROLES,
  payload: {
    fetchingStaticJobRoles: true,
    fetchStaticJobRolesError: null,
  },
})

export const fetchStaticJobRolesSuccess = ({ result }) => ({
  type: FETCH_STATIC_JOB_ROLES_SUCCESS,
  payload: {
    fetchingStaticJobRoles: false,
    lastUpdatedStaticJobRoles: Date.now(),
    staticJobRoles: result.map(city => city.id),
  },
})

export const fetchStaticJobRolesError = errorMessage => ({
  type: FETCH_STATIC_JOB_ROLES_ERROR,
  error: true,
  payload: new Error(errorMessage),
})

const defaultMap = {
  staticJobRoles: [],
  lastUpdatedStaticJobRoles: null,
  fetchingStaticJobRoles: false,
  fetchStaticJobRolesError: null,
}

const map = (state = defaultMap, { type, payload }) => {
  switch (type) {
    case FETCH_STATIC_JOB_ROLES:
    case FETCH_STATIC_JOB_ROLES_SUCCESS:
      return { ...state, ...payload }

    case FETCH_STATIC_JOB_ROLES_ERROR:
      return {
        ...state,
        fetchingStaticJobRoles: false,
        fetchStaticJobRolesError: payload,
      }

    default:
      return state
  }
}

export default map

export const getRoleListView = state => state.views.roleList
